import {objectToFormData} from "./forms";

/**
 * Wrapper für fetch-API
 * ergänzt Header, damit Backend ajax-Requests erkennen kann
 *
 * @param RequestInfo input
 * @param RequestInit init
 * @returns Promise<Response>
 */
export async function fetch(input, init = {}) {
  if (!init.headers) {
    init.headers = new Headers();
  }
  init.headers.set('x-Requested-With', 'XMLHttpRequest');
  return window.fetch(input, init);
}

/**
 * Führt Fetch-Request aus und gibt Json-Objekt zurück
 *
 * @param RequestInfo input
 * @param RequestInit init
 * @returns Promise<object>
 */
export function fetchJson(input, init = {}) {
  if (!init.headers) {
    init.headers = new Headers();
  }
  init.headers.set('Accept', 'application/json');
  return fetch(input, init)
    .then(response => response.json());
}

/**
 * Führt fetch-Request aus und gibt Response-Text zurück
 *
 * @param RequestInfo input
 * @param RequestInit init
 * @returns Promise<string>
 */
export function fetchText(input, init = {}) {
  return fetch(input, init)
    .then(response => response.text());
}


/**
 * Lädt den Content von url in das Element target
 *
 * @param {string} url
 * @param {Element|string} target
 * @param  options (optional)
 * @returns {Promise<Element>} target
 */
export async function load(url, target, options = {}) {
  if (!(target instanceof Element)) {
    target = document.querySelector(target);
  }
  let id = null;
  [url, id] = (url.split('#'));

  if (!target) {
    return Promise.reject({code: 1, message: "Target not found."});
  }
  if (!url) {
    return Promise.reject({code: 2, message: "No url given."});
  }
  if (options.data) {
    options.method = 'POST';
    options.body = objectToFormData(options.data);
    delete options.data
  }
  options.method ??= 'GET';
  return window.fetch(url, options)
    .then(response => response.text())
    .then(html => {
      if (id) {
        const doc = document.createElement('div');
        doc.innerHTML = html;
        const content = doc.querySelector(`#${id}`);
        if (content !== null) {
          html = content.innerHTML;
        }
      }
      target.innerHTML = html;
      return target;
    });
}

